export const isLocationCheckInError = error => (
  /GPS|position|location permission|Capture position/i.test(error?.message || '')
);

// Only expose location-specific errors. Other server/network errors retain generic UI copy.
export function statusCheckInErrorMessage(error, caller = 'dropdown') {
  if (!isLocationCheckInError(error)) return 'We couldn’t save your check-in. Please try again.';
  if (caller === 'gate') {
    return 'We couldn’t save your check-in. Please try again. Your answer and note remain here.';
  }
  return 'Check-in not saved. Open Profile → Privacy to review Capture position when filing, allow location permission in your device and app settings, turn on GPS, then retry. Your answer and note remain here.';
}
